
import html2pdf from "html2pdf.js";
import { useNavigate } from "react-router-dom";
import { MdLocalPrintshop, MdOutlineClose } from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import Invoice from "./invoice";

export default function SectionTwo() {
  const navigate = useNavigate();

  const handleDownload = () => {
    const element = document.getElementById("invoice-invoice");
    if (!element) return;

    const opt = {
      margin:       0.5,
      filename:     `invoice_${Date.now()}.pdf`,
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(element).save();
  };
  const handlePrint = () => {
  const content = document.getElementById("invoice-invoice");
  if (!content) return;

  const printWindow = window.open('', '', 'width=800,height=600');
  const clonedContent = content.cloneNode(true);

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Shipping Label</title>
          <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
          <style>
            @media print {
              @page {
                margin: 20mm;
              }
              body {
                font-family: sans-serif;
              }
            }
          </style>
        </head>
        <body>
          ${clonedContent.outerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  }
};

  return (
    <section className="bg-white p-4">
      <div className="flex flex-col md:flex-row gap-5">
        <div className="w-3/4 border">
          <Invoice />
        </div>
        <div className="w-1/4 flex flex-col space-y-3 py-5 items-center">
          <button className="text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
           text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
          onClick={handlePrint}>
            <MdLocalPrintshop />
            <p>Print</p>
          </button>
          <button
            className="text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
           text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
            onClick={handleDownload}
          >
            <IoMdDownload className="text-xl"/>
            <p>Download</p>
          </button>
          <button
            className="text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
           text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
            onClick={() => navigate(-1)}
          >
            <MdOutlineClose />
            <p>Close Preview</p>
          </button>
        </div>
      </div>
    </section>
  );
}
